import React from 'react';
import GlobalStyles from './styles/GlobalStyles';
import { ThemeProvider } from 'styled-components';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import theme from './styles/theme';
import Navbar from './components/Navbar/Navbar';
import Hero from './components/Hero/Hero';
import About from './components/About/About';
import Services from './components/Services/Services';
import TechStack from './components/TechStack/TechStack';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import { EduSentryPage, GeoCRMPage, ECartPage, EMASPage } from './components/Products/ProductPages';
import EduNexusPage from './components/Products/EduNexusPage';
import ClientsPage from './components/Clients/ClientsPage';
import PrivacyPolicy from './components/Privacy/PrivacyPolicy';

// Main homepage component
const HomePage = () => (
  <>
    <Hero />
    <About />
    <TechStack />
    <Contact />
  </>
);
function App() {

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <Router>
        <Navbar />
        <Routes>
          <Route
            path="/"
            element={<HomePage />}
          />
          <Route path="/products/edunexus" element={<EduNexusPage />} />
          <Route path="/products/geocrm" element={<GeoCRMPage />} />
          <Route path="/clients" element={<ClientsPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
        <Footer />
      </Router>
    </ThemeProvider>
  );
}

export default App;
